//#region src/utils/hidePiiData.ts
var e = "data-original-pii", t = "data-obfuscated-pii", n = (e) => {
	for (let t = e.length - 1; t > 0; t--) {
		let n = Math.floor(Math.random() * (t + 1)), r = e[t];
		e[t] = e[n], e[n] = r;
	}
}, r = (e) => /[A-Za-z0-9]/.test(e), i = (e) => {
	let t = "";
	for (let n = 0; n < e; n++) t += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".charAt(Math.floor(Math.random() * 52)).toLocaleLowerCase();
	return t;
}, a = (e, t = 6) => e.length >= t ? e : e + i(t - e.length), o = (e) => {
	let t = "";
	for (let n = 0; n < e; n++) t += "0123456789".charAt(Math.floor(Math.random() * 10));
	return t;
}, s = (e, t = 6) => e.length >= t ? e : e + o(t - e.length), c = (e) => {
	let t = e.length, i = e.split(""), a = [], o = [];
	for (let e of i) r(e) ? a.push(e) : o.push(e);
	if (a.length === 0 || t >= 2 && a.length === 1) return e;
	n(a), n(o);
	let s = Math.max(0, t - 2);
	if (o.length > s) return e;
	let c = Array(t);
	c[0] = a.pop(), c[t - 1] = a.pop();
	let l = [];
	for (let e = 1; e <= t - 2; e++) l.push(e);
	n(l);
	let u = 0;
	for (let e of o) c[l[u++]] = e;
	for (let e of a) c[l[u++]] = e;
	return c.join("");
}, l = (e) => {
	let [t, n] = e.split("@"), r = t.replace(/[^A-Za-z0-9]/g, ""), i = n.replace(/[^A-Za-z0-9]/g, "");
	return `${d(a(r, 6), !1)}@${d(i, !1)}.${(() => {
		try {
			let e = (typeof navigator < "u" && (navigator.languages?.[0] || navigator.language) || "").replace("_", "-");
			if (!e) return "com";
			let t = e.split("-");
			return (t[1] || t[0] || "").slice(0, 2).toLocaleLowerCase() || "com";
		} catch {
			return "com";
		}
	})()}`;
}, u = (e) => {
	let t = e.startsWith("+") && e.slice(1).match(/^\d{1,3}/)?.[0] || "", n = e.replace(/\D/g, ""), r = t ? n.slice(t.length) : n;
	if (r.length < 4) return e;
	let i = c(s(r, 6)), a = 0, o = t.length, l = !!t;
	return e.replace(/\d/g, (e) => {
		if (l) {
			if (o > 0) return --o, o === 0 && (l = !1), e;
			l = !1;
		}
		return i[a++] || "0";
	});
}, d = (e, t = !0) => {
	if (e.length < 2) return e;
	let n = c(a(e.replace(/[^A-Za-z]/g, ""), 6));
	return t ? n.charAt(0).toUpperCase() + n.slice(1).toLowerCase() : n;
}, f = (e) => e.replace(/(^|[^A-Za-z0-9])(\+?\d(?:[ \t\-()]*\d){6,})(?=$|[^A-Za-z0-9])/g, (e, t, n) => t + u(n)).replace(/\S+/g, (e) => /^[^@]+@[^@]+$/.test(e) ? l(e) : /^\+?[0-9][0-9\s\-()]{3,}$/.test(e) ? u(e) : /[A-Za-z]/.test(e) ? d(e.length < 6 ? e + i(6 - e.length) : e) : e), p = (n, r) => {
	let i = n instanceof Element ? [n] : Array.from(n);
	for (let n of i) {
		n.setAttribute("data-pii", "hidden");
		let i = (n.textContent || "").trim();
		if (n.matches?.("input") || n.tagName === "INPUT") {
			let i = n, a = i.value || "";
			if (typeof r == "string" && r.length > 0) {
				n.setAttribute(e, a), i.value = r, n.setAttribute(t, i.value);
				continue;
			}
			if (n.setAttribute(e, a), a.trim().length > 0) {
				let e = f(a);
				e !== a && (i.value = e), n.setAttribute(t, i.value);
			}
			continue;
		}
		let a = (e, t) => {
			if (e.children.length === 1) {
				let n = e.children[0];
				if (n && n.children.length === 0) {
					n.textContent = t;
					return;
				}
			}
			let n = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null), r = [], i = n.nextNode();
			for (; i;) {
				let e = i;
				(e.nodeValue || "").trim().length > 0 && r.push(e), i = n.nextNode();
			}
			if (r.length === 0) {
				e.textContent = t;
				return;
			}
			r[0].nodeValue = t;
			for (let e = 1; e < r.length; e++) r[e].nodeValue = "";
		};
		if (typeof r == "string" && r.length > 0) {
			i && n.setAttribute(e, i), a(n, r), n.setAttribute(t, (n.textContent || "").trim());
			continue;
		}
		let o = !1, s = document.createTreeWalker(n, NodeFilter.SHOW_TEXT, null), c = s.nextNode();
		for (; c;) {
			let e = c, t = String(e.textContent || "");
			if (/^\s*$/.test(t)) {
				let t = s.nextNode();
				e.remove(), c = t;
				continue;
			}
			let n = t.replace(/\s+/g, " ");
			if (n.trim().length > 0) {
				let t = f(n);
				t !== n && (e.textContent = t, o = !0);
			}
			c = s.nextNode();
		}
		let l = Array.from(n.childNodes).filter((e) => e.nodeType === Node.TEXT_NODE);
		for (let e = 0; e < l.length - 1; e++) {
			let t = l[e], n = l[e + 1];
			if (t.textContent?.trim() && n.textContent?.trim()) {
				let e = document.createTextNode(" ");
				t.parentNode?.insertBefore(e, n);
			}
		}
		let u = (n.textContent || "").trim();
		o && u && (n.setAttribute(t, u), i && n.setAttribute("data-original-pii", i));
	}
};
//#endregion
export { p as hidePiiData, f as shufflePii, d as shuffleText };

//# sourceMappingURL=hidePiiData.js.map